// extracted by mini-css-extract-plugin
module.exports = {"backgroundImage":"Image_backgroundImage__4RofT"};